export default "__VITE_ASSET__BElqODlj__"